import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonUtilsModule } from "../common-utils/common-utils.module";
import { CommonToggleDisplayActionsDirective } from "./actions.directive";
import { CommonToggleDisplayComponent } from "./common-toggle-display.component";
import { toggleDisplayStatePropProvider } from "./state-props";
import { CommonToggleControlDirective } from "./toggle-control.directive";
import { ToggledContentSelectedDirective } from "./toggle-identifier.directive";

@NgModule({
    imports: [
        CommonModule,
        CommonUtilsModule,
    ],
    exports: [
        CommonToggleDisplayComponent,
        CommonToggleDisplayActionsDirective,
        CommonToggleControlDirective,
        ToggledContentSelectedDirective,
    ],
    declarations: [
        CommonToggleDisplayComponent,
        CommonToggleDisplayActionsDirective,
        CommonToggleControlDirective,
        ToggledContentSelectedDirective,
    ],
    providers: [
        CommonToggleDisplayActionsDirective,
        toggleDisplayStatePropProvider,
    ],
})
export class CommonToggleDisplayModule {
}
